import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ModelService from "services/ModelService";

export default function NukeCategories(params) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const nuke = () => {
    ModelService.nukeModels(() =>
      window.confirm("You are about to delete all categories. Are you sure?")
    ).then((didNuke) => {
      handleClose();
    });
  };

  return (
    <>
      <Button className="m-2" variant="danger" onClick={handleShow}>
        Delete All Categories
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete all categories?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you would like to delete all categories? <br />
          Existing games will <b>not</b> be effected.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={nuke}>
            Delete All Categories
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
